import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
import { buildQuery } from '@calendly/http-tools'

import { eventTypeSelector } from 'root-api'
import { useI18n, i18n } from 'locales'

import { useFeatures } from './use_organization'
import { useProfile } from './use_profile'
import { useRoutingForm } from './use_routing_form'
import _Badge from "branding-Badge.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/branding.js?styleId=Badge";
import _Container from "branding-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/branding.js?styleId=Container";
import _PoweredBy from "branding-PoweredBy.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/branding.js?styleId=PoweredBy";
import _Calendly from "branding-Calendly.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/branding.js?styleId=Calendly";


const backgroundColor = '#505960'
const altTextColor = '#ffffff'

const Badge = /*#__PURE__*/styled('div', null, {
  displayName: "Badge",
  styles: _Badge,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const size = '105px'

const Container = /*#__PURE__*/styled('a', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    target: '_blank',
    isPhone: useDeviceType('isPhone'),
    isTabletUp: useDeviceType('isTabletUp')
  })
})

const PoweredBy = /*#__PURE__*/styled('div', null, {
  displayName: "PoweredBy",
  styles: _PoweredBy,
  attrs: props => ({
    ...props,
    children: useI18n().i18n.t('booking.badge'),
    isPhone: useDeviceType('isPhone')
  })
})

const Calendly = /*#__PURE__*/styled('div', null, {
  displayName: "Calendly",
  styles: _Calendly,
  attrs: props => ({
    ...props,
    children: 'Calendly'
  })
})

export const RenderBranding = (props) => {
  const profile = useProfile()
  const eventType = useSelector(eventTypeSelector)
  const routingForm = useRoutingForm()

  if (eventType?.unbranded || profile?.unbranded || routingForm?.organization?.unbranded) {
    return null
  }

  const translatedLocales = ['fr', 'es', 'de', 'pt']
  const locale = translatedLocales.includes(i18n.locale) ? i18n.locale : ''
  const query = buildQuery({
    utm_campaign: 'sign_up',
    utm_medium: 'badge',
    utm_source: 'invitee'
  })

  const href = `${props.badge.path}${locale}?${query}`

  return (
    <Container href={href}>
      <Badge data-id="branding">
        <PoweredBy />
        <Calendly />
      </Badge>
    </Container>
  )
}

const Branding = () => {
  const { data } = useFeatures()

  if (!data) return null

  return <RenderBranding badge={data.badge} />
}

export default Branding
